import React from "react";
import styled from "styled-components";
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 0rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: rgb(255, 255, 255);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.1rem;
  }
`;

const Emphasis = styled.span`
  color: #007acc;
  font-weight: bold;
`;

const SubTitle = styled.h2`
  font-size: 2rem;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Text = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: rgb(235, 232, 232);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const PrivacyPolicy = () => {
  return (
    <Container>
      <Title>
        Privacy <Emphasis>Policy</Emphasis>
      </Title>

      <Text>
        Your privacy is important to us. This{" "}
        <Emphasis>Privacy Policy</Emphasis> explains how we collect, use,
        disclose, and safeguard your information when you visit our website.
      </Text>

      <SubTitle>1. Information We Collect</SubTitle>
      <Text>
        We may collect personal data such as your name, email address, and any
        other information you provide.
      </Text>

      <SubTitle>2. How We Use Your Information</SubTitle>
      <Text>
        We use your data to improve our service, communicate with you, and
        ensure the best experience on our site.
      </Text>

      <SubTitle>3. Contact Us</SubTitle>
      <Text>
        If you have questions about this policy, contact us at{" "}
        <a href="mailto:techveda.info@gmail.com">techveda.info@gmail.com</a>.
      </Text>
    </Container>
  );
};

export default PrivacyPolicy;
